<template>
  <div id="auth" class="container align-all">
    <section id="auth-content" class="box padding install">
      <h2>Convite para Acesso</h2>
      <form class="margin-top-l">
        <div class="item">
          <div class="flex between">
            <label>Nome da Conta:</label>
          </div>
          <input v-model="accname" type="text" readonly="true" disabled />
        </div>
        <div class="margin-top-l">
          Vamos criar um usuário para você ter acesso a plataforma, para isso você precisa definir a senha abaixo:
        </div>
        <div class="item margin-top-l">
          <div class="flex between">
            <label>Email:</label>
          </div>
          <input v-model="email" type="text" readonly="true" disabled />
        </div>
        <div class="item margin-top-l">
          <div class="flex between">
            <label>Nova senha</label>
          </div>
          <input v-model="password1" type="password" />
        </div>
        <div class="item">
          <div class="flex between">
            <label>Repita a senha:</label>
          </div>
          <input v-model="password2" type="password" />
        </div>
      </form>

      <div class="login-buttons recovery margin-top-l flex column">
        <div>
          <a @click="acceptInvite()" class="button primary full">ACEITAR CONVITE</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { changePassword } from "@/services/auth";

export default {
  name: "invite-new-user",
  props: ["rtoken"],
  data() {
    return {
      password1: "",
      password2: "",
      accname: "",
      email: "",
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)
    this.accname = params.get('accname')
    if (this.accname) {
      this.accname = decodeURIComponent(this.accname)
    }
    this.email = params.get('email')
  },
  methods: {
    acceptInvite() {
      if (this.password1 != this.password2) {
        return this.$toast.error({
          title: "Erro",
          message: "A senha digitada não confere com a sua repetição"
        });
      }
      changePassword({
        token: this.rtoken,
        password1: this.password1,
        password2: this.password2
      })
        .then(response => {
          this.$toast.success({
            title: "Sucesso",
            message: "Convite aceito com sucesso"
          });

          this.$store.dispatch("auth", { token: response.auth_token });
          this.$router.push({ name: "Account" });
        })
        .catch(error => {
          if (error && error.message === "request-canceled") {
            return;
          }

          return this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro interno"
          });
        });
    }
  }
};
</script>

<style lang="scss">
input {
  &:disabled {
    //color: #c2c2c2;
    background: #c2c2c2;
  }
}
</style>